export default __webpack_public_path__ + "static/media/ramadan.31baf022.png";